import { useState } from "react";
import { useHistory } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import Router from "../..";
import { fileToBase64 } from "../../utils/fileToBase64";
import dayjs from "dayjs";
import { useUserStore } from "../../../stores/userStore";
import { BRAND_CONTRACT_TERMS } from "../../components/Contract";
import { useCreateCampaign } from "../../hooks/useCampaign";

export const CreateCampaign = () => {
  const history = useHistory();
  const { userInfo } = useUserStore();
  const { mutateAsync: createCampaign } = useCreateCampaign();
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [attachmentFile, setAttachmentFile] = useState(null);

  const handleCreate = async (values) => {
    let thumbnailBuffer = null;
    let attachmentBuffer = null;

    if (thumbnailFile) {
      thumbnailBuffer = await fileToBase64(thumbnailFile);
    }
    if (attachmentFile) {
      attachmentBuffer = await fileToBase64(attachmentFile);
    }
    const contentFormat = values.content_format.join(",");

    const contractPayload = {
      sign: {
        title: BRAND_CONTRACT_TERMS.title,
        version: BRAND_CONTRACT_TERMS.version,
        terms_url: BRAND_CONTRACT_TERMS.terms_url,
        username: values.username,
        sign_date: dayjs().format("YYYY-MM-DD"),
        user_type: "brand",
        company_name: values.company_name,
      },
    };

    const campaignData = {
      manager_user_id: userInfo?.user_info?.id,
      title: values.title,
      description: values.description,
      mission: values.mission,
      content_format: contentFormat,
      campaign_category: values.category,
      seeding_type: values.seeding_type,
      recruit_count: values.recruitment_count,
      budget: "0.00",
      payout: values.payout ? values.payout.toString() + ".00" : 0,
      currency: values.currency,
      start_at: values.start_date.format("YYYY-MM-DD") + "T00:00:00Z",
      end_at: values.end_date.format("YYYY-MM-DD") + "T14:59:59Z",
      requires_shipment: values.requires_shipment,
      sign: contractPayload.sign,
      product_info: values.product_info,
      allow_secondary_use: values.allow_secondary_use,
    };

    if (thumbnailBuffer) {
      campaignData.thumbnail = thumbnailBuffer;
    }
    if (attachmentBuffer) {
      campaignData.attachment_url = attachmentBuffer;
    }

    const success = await createCampaign(campaignData);

    if (success) {
      history.push("/campaign/manage");
    }
  };

  return (
    <div>
      <div className="mb-12 flex items-center gap-4 sm:gap-6">
        <button
          type="button"
          onClick={() => history.push("/campaign/manage")}
          className="inline-flex shrink-0 items-center justify-center p-3 text-gray-700 transition-colors"
          aria-label="캠페인 관리로 돌아가기"
        >
          <ArrowLeftOutlined className="text-2xl leading-none md:text-3xl" />
        </button>
        <h1 className="text-2xl font-bold tracking-tight text-gray-900 md:text-4xl">
          캠페인 생성하기
        </h1>
      </div>

      <Router.CampaignForm
        mode="create"
        onFinish={handleCreate}
        onThumbnailChange={setThumbnailFile}
        onAttachmentChange={setAttachmentFile}
      />
    </div>
  );
};
